// @flow
import * as React from 'react';
import { SocialButton } from 'components/SocialButton';
import Icon from 'components/Icon';
import Box from 'components/Box';
import type { PublicPage } from 'api/website';

export default ({
  content,
  message,
  title,
  subsite
}: {
  content: PublicPage,
  message: ?string,
  title: string,
  subsite: string
}) => (
  <>
    <SocialButton
      object={content}
      objectType="CMS_PAGE"
      socialType="facebook"
      utmParams={{}}
      message={message}
      eventName="Share post"
      eventProperties={{
        title,
        subsite
      }}
    >
      <Box
        width={32}
        height={32}
        classes={['flex', 'justify-center', 'align-center']}
      >
        <Icon name="facebook" width={14} height={14} fill="currentColor" />
      </Box>
    </SocialButton>

    <SocialButton
      object={content}
      objectType="CMS_PAGE"
      socialType="twitter"
      utmParams={{}}
      message={message}
      eventName="Share post"
      eventProperties={{
        title,
        subsite
      }}
    >
      <Box
        width={32}
        height={32}
        classes={['flex', 'justify-center', 'align-center']}
      >
        <Icon name="twitter" width={14} height={14} fill="currentColor" />
      </Box>
    </SocialButton>

    <SocialButton
      object={content}
      objectType="CMS_PAGE"
      socialType="linkedin"
      utmParams={{}}
      message={message}
      eventName="Share post"
      eventProperties={{
        title,
        subsite
      }}
    >
      <Box
        width={32}
        height={32}
        classes={['flex', 'justify-center', 'align-center']}
      >
        <Icon name="linkedin" width={14} height={14} fill="currentColor" />
      </Box>
    </SocialButton>
  </>
);
